import React from 'react'
import { DownloadIcon } from '../../assets/icons/download-four'
import { ButtonDownload, LinkDownload } from './styles'
import { colors } from '../../theme'

type SheetsDownloadProps = {
  url: String
  text: string
}

function SheetsDownload({ url, text }: SheetsDownloadProps) {
  return (
    <ButtonDownload>
      <LinkDownload href={url as string}>
        <DownloadIcon color={colors.white} /> {text}
      </LinkDownload>
    </ButtonDownload>
  )
}
export default SheetsDownload
